"use client";

import { ComponentPropsWithoutRef, FC } from "react";
import { ReactSVG } from "react-svg";
import { BooleanParam, useQueryParam, withDefault } from "use-query-params";
import Button from "./Button";

export const SHOW_TIMELINE_PARAM = "timeline";

type HideTimelienButtonProps = {} & ComponentPropsWithoutRef<"button">;

const HideTimelienButton: FC<HideTimelienButtonProps> = ({ ...rest }) => {
  const [showTimeline, setShowTimeline] = useQueryParam(
    SHOW_TIMELINE_PARAM,
    withDefault(BooleanParam, true),
    {
      updateType: "replaceIn",
    }
  );

  return (
    <Button
      {...rest}
      onClick={() => setShowTimeline(!showTimeline)}
      className={`${rest.className}`}
      size="m"
      variant="tertiary"
      data-tooltip-content={showTimeline ? "Hide timeline" : "Show timeline"}
      data-tooltip-id="global"
    >
      <ReactSVG src="/svg/pannel_bottom.svg" className="stroke-foreground" />
    </Button>
  );
};

export default HideTimelienButton;
